import React, { useState, useEffect } from 'react';
import './Header.css';
import { ReactComponent as Logo } from '../../../assets/images/logo.svg'
import { Link, useLocation } from 'react-router-dom';

const Header = ({ openLoginModal, isAuthenticated, alwaysSolid = false }) => {
    const [menu, setMenu] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <header className={`header ${scrolled || alwaysSolid ? 'header-scrolled header-solid' : ''}`}>
            <nav className="container header-navbar">
                <Link to={'/'} className='header-logo'>
                    <Logo className="header-logo-svg" />
                </Link>
                <div className={`header-right ${menu && 'active'}`}>
                    <ul className='header-navlinks'>
                        <li>
                            <Link to="/" className={isActive('/') ? 'active' : ''} onClick={() => setMenu(false)}>Home</Link>
                        </li>
                        <li>
                            <Link to="/clubs" className={isActive('/clubs') ? 'active' : ''} onClick={() => setMenu(false)}>Clubs</Link>
                        </li>
                        {!isAuthenticated && (
                            <li>
                                <Link to="/register" className={isActive('/register') ? 'active' : ''} onClick={() => setMenu(false)}>Register</Link>
                            </li>
                        )}
                        <li>
                            <Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={() => setMenu(false)}>About</Link>
                        </li>
                    </ul>
                    <div className="header-ctas">
                        {isAuthenticated ? (
                            <Link to="/dashboard" className='header-dashboard-btn' onClick={() => setMenu(false)}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                                Dashboard
                            </Link>
                        ) : (
                            <button onClick={() => { openLoginModal(); setMenu(false); }} className='header-login-btn'>
                                <span>Sign In</span>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
                <div
                    id="menu-icon"
                    className={menu === true ? 'open' : ''}
                    onClick={() => setMenu(!menu)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </nav>
        </header>
    );
};

export default Header;
